import Axios from 'axios';

const Api = Axios.create({
    baseURL: window.env.REACT_APP_API_URL,
    headers: {
        'content-type': 'application/json'
    }
});

export default Api;